const eventsMapper = () => null;

export default eventsMapper;
